import { ThemeProvider as NextThemesProvider, useTheme } from "next-themes"
import { type ReactNode, useEffect, useRef } from "react"
import { useAuth } from "@/hooks/auth/use-auth"
import { isValidTheme } from "@/lib/theme"

function ThemeLoader() {
	const { user } = useAuth()
	const { setTheme } = useTheme()
	const hasSynced = useRef(false)

	useEffect(() => {
		if (!user || hasSynced.current) return
		hasSynced.current = true
		const savedTheme = user.user_metadata?.theme
		if (isValidTheme(savedTheme)) {
			setTheme(savedTheme)
		}
	}, [user, setTheme])

	return null
}

export function ThemeProvider({ children }: { children: ReactNode }) {
	return (
		<NextThemesProvider
			attribute="class"
			defaultTheme="system"
			enableSystem
			storageKey="hecla-theme"
			disableTransitionOnChange
		>
			<ThemeLoader />
			{children}
		</NextThemesProvider>
	)
}
